import Dropdown from "./../components/Dropdown";

export default () => {
	const filtersWrapper: HTMLElement | null = document.querySelector(
		".block.recipes-list .block__filters"
	);

	if (!filtersWrapper) return;

	const filters: HTMLElement[] = Array.from(
		filtersWrapper.querySelectorAll(".dropdown")
	);

	filters.map((filter: HTMLElement) => Dropdown(filter, filtersWrapper));

	const open: HTMLSpanElement | null = document.querySelector(
		".block.recipes-list .filters__open"
	);
	const close: HTMLSpanElement | null = document.querySelector(
		".block.recipes-list .filters__close"
	);
	const filtersContainer: HTMLDivElement | null = document.querySelector(
		".block.recipes-list .block__filters"
	);

	if (open && filtersContainer && close) {
		open.onclick = () => {
			filtersContainer.classList.add("open");
		};

		close.onclick = () => {
			filtersContainer.classList.remove("open");
		};
	}
};
